<template>
  <div id="index">
    <el-container class="LabBG">
      <el-header height="70px">
        <el-row :gutter="24">
          <el-col :span="6" style="padding-left: 32px">
            <img src="~assets/img/NokiaBellLogo1.png" />
          </el-col>
          <el-col :span="12">
            <h2>{{ labName }}</h2>
          </el-col>
          <el-col
            :span="6"
            style="margin-top: 10px; width: auto; margin-left: 0.77rem"
          >
            <span>
              Contact：<strong style="margin-right: 10px">{{
                contactName
              }}</strong
              ><br />
              Mobile Phone：<strong>{{ contactMobile }}</strong> </span
            ><br />
            <span class="time">{{ timesNow }}</span>
          </el-col>
        </el-row>
      </el-header>

      <el-main>
        <el-row :gutter="24" class="mainTop">
          <el-col
            :span="8"
            style="position: relative; padding-top: 10px; text-align: center"
          >
            <h3
              class="gridTitle-Total"
              style="
                background-image: -webkit-linear-gradient(
                  left,
                  #dee9fb,
                  #b3cdff
                );
              "
            >
              Electrical Safety Index
            </h3>
            <span class="el-title" :style="LabNameTop">{{ subEname }}</span>
            <img id="imgid" :src="imgurl1" class="Stateimg" />

            <el-row :gutter="24">
              <el-col :span="24">
                <el-tabs
                  :style="tabHeight"
                  class="labTab"
                  v-model="EActiveTabs"
                  type="card"
                  ref="ETab"
                >
                  <el-tab-pane
                    v-for="(item, index) of sortElcList"
                    :key="index"
                    :name="item.name"
                  >
                    <span slot="label" :class="item.styleClass">{{
                      item.name.substring(item.name.lastIndexOf("-") + 1)
                    }}</span>
                  </el-tab-pane>
                  <el-row :gutter="24">
                    <el-col :span="12">
                      <div class="grid-content bg-blue">
                        <h3 class="gridTitle">Unbalanced 3-Phase Current</h3>
                        <div
                          class="Lab_Echarts"
                          id="ElcTri"
                          :style="LeftHeight"
                        ></div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-blue">
                        <h3 class="gridTitle">Active Power</h3>
                        <div
                          class="Lab_Echarts"
                          id="InsPower"
                          :style="LeftHeight"
                        ></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-tabs>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="24">
                <div class="grid-content bg-blue">
                  <h3 class="gridTitle">3-Phase Current</h3>
                  <div class="Lab_Echarts" id="Elc3" :style="TopHeight"></div>
                </div>
              </el-col>
            </el-row>
            <img src="~assets/img/gridbg1.png" class="gridBG" />
          </el-col>
          <el-col
            :span="8"
            style="position: relative; padding-top: 10px; text-align: center"
          >
            <h3
              class="gridTitle-Total"
              style="
                background-image: -webkit-linear-gradient(
                  left,
                  #d2f9f9,
                  #87f1ff
                );
              "
            >
              Power Trending
            </h3>
            <img :src="imgurl3" class="Stateimg" />
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="grid-content bg-blue">
                  <h3 class="gridTitle">Monthly Tracking(KWh)</h3>
                  <div
                    class="Lab_Echarts"
                    id="ElcKPI"
                    :style="CenterHeight"
                  ></div>
                </div>
              </el-col>
              <el-col :span="24" style="margin-top: 22px">
                <div class="grid-content bg-blue">
                  <el-row :gutter="24">
                    <el-col :span="9">
                      <h3 class="gridTitle">Current Month PUE</h3>
                    </el-col>
                    <el-col :span="7">
                      <div class="realPUE" :style="RealHeight" >
                        Latest
                        <strong>{{PueRealData}}</strong>
                      </div>
                    </el-col>
                    <el-col
                      :span="8"
                      style="text-align: right; display: inline-table"
                    >
                      <h3 class="gridTitle righttitle">Last Month PUE</h3>
                    </el-col>

                    <el-col :span="12">
                      <div
                        class="Lab_Echarts"
                        id="NowPUE"
                        :style="CenterBHeight"
                      ></div>
                    </el-col>

                    <el-col :span="12">
                      <div
                        class="Lab_Echarts"
                        id="LastPUE"
                        :style="CenterBHeight"
                      ></div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <img src="~assets/img/gridbg2.png" class="gridBG" />
          </el-col>
          <el-col
            :span="8"
            style="position: relative; padding-top: 10px; text-align: center"
          >
            <h3
              class="gridTitle-Total"
              style="
                background-image: -webkit-linear-gradient(
                  left,
                  #c6f6de,
                  #85d8b4
                );
              "
            >
              Environment Index
            </h3>
            <div class="OutDoorTH" v-show="showOutTH">
              <span>Outdoor T/H：<strong>{{outTempV1}}℃ / {{outHumV1}}%</strong></span>
            </div>
            <span class="el-title" :style="LabNameTop">{{ subThname }}</span>
            <img :src="imgurl2" class="Stateimg" />
            <el-row :gutter="24">
              <el-col :span="24">
                <el-tabs
                  :style="tabHeight"
                  class="labTab1"
                  v-model="TActiveTabs"
                  type="card"
                  ref="THTab"
                >
                  <el-tab-pane
                    :name="item.name"
                    v-for="(item, index) of sortTHList"
                    :key="index"
                  >
                    <span slot="label" :class="item.styleClass">{{
                      item.code.substring(item.code.lastIndexOf("-") + 1)
                    }}</span>
                  </el-tab-pane>
                  <div class="grid-content bg-blue">
                    <h3 class="gridTitle">Temperature/Humidity</h3>
                    <el-row :gutter="24">
                      <el-col :span="12">
                        <div
                          class="Lab_Echarts"
                          id="Temperature"
                          :style="RightHeight"
                        ></div>
                      </el-col>
                      <el-col :span="12">
                        <div
                          class="Lab_Echarts"
                          id="Humidity"
                          :style="RightHeight"
                        ></div>
                      </el-col>
                    </el-row>
                  </div>
                </el-tabs>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="grid-content bg-blue">
                  <h3 class="gridTitle">Layout</h3>

                  <img :src="targetUrl" class="labpic" :style="TopHeight" />
                </div>
              </el-col>
            </el-row>
            <img src="~assets/img/gridbg3.png" class="gridBG" />
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import * as signalR from "@microsoft/signalr";
import { mapState } from "vuex";
import echarts from "echarts";
import "echarts-liquidfill";
import {
  getDeviceByLabId,
  getOtherDeviceByLabId,
  getLabScreenInfo,
  GetMyRegionChainList,
  GetEqPueData,
  GetKpiData,
  SendWeChat,
  GetMyListDatapermission,
  GetRealPueData,
  GetOutTempData,
} from "../../api/api";
import n_green from "../../assets/img/TopState1G.png";
import n_yellow from "../../assets/img/TopState1Y.png";
import n_red from "../../assets/img/TopState1R.png";

import T_green from "../../assets/img/TopState3G.png";
import T_yellow from "../../assets/img/TopState3Y.png";
import T_red from "../../assets/img/TopState3R.png";
import { refreshMyToken } from "../../utils/util";
import { getCookie ,setCookie} from "../../../utils/package-cookies";
//import { connection } from "../../api/signalr";nsbseelabdev-azurefunction.nokia-sbell.com
//let hubUrl = "https://nsbseelab-dev.chinacloudsites.cn/api/";
let hubUrl = process.env.VUE_APP_SignarlUrl; // "http://nsbseelabdev-azurefunction.nokia-sbell.com/api/";
const connection = new signalR.HubConnectionBuilder()
  .withAutomaticReconnect() //断线自动重连
  .withUrl(hubUrl)
  //.configureLogging(signalR.LogLevel.Information)
  .build();
connection.onclose(() => console.log("disconnected"));
export default {
  name: "index",
  inject: ["reload"],
  data() {
    return {
      currLabId:"",
      testlev: "0",
      imgurl: require("@/assets/img/TopState1G.png"),
      imgurlG: n_green,
      imgurlY: n_yellow,
      imgurlR: n_red,
      timgurl: T_green,
      timgurlG: T_green,
      timgurlY: T_yellow,
      timgurlR: T_red,
      labId: "",
      elcdevice: "",
      device: "",
      outdevice:"",
      labName: "",
      contactName: "",
      contactMobile: "",
      targetUrl: "",
      //电表各项值
      Ia: "",
      Ib: "",
      Ic: "",
      W: "",
      imbalenceIndex: "",
      ratedCurrent: 30, //额定电流
      ratedVoltage: 0, //额定电压
      magnification: 1,
      ethLevelt: 0, //电表告警级别
      ethLevel: 0,
      thridList: [], //当前电表阈值集合
      currTempTypeList: [], //当前温度表阈值集合
      currHumTypeList: [], //当前湿度表阈值集合
      outcurrTempTypeList:[],//当前室外温度表阈值集合
      outcurrHumTypeList:[],//当前室外湿度表阈值集合
      THTemp: "",
      THHum: "",

      outTHTemp: "",
      outTHHum: "",
      outTempV1:"",//从气象台获取温度数据
      outHumV1:"",//从气象台获取湿度数据
      //pue
      lastpue: "",
      currpue: "",
      elclevList: [], //电表告警级别
      thlevList: [], //温湿度告警级别
      reportList: [], //已发送记录
      //实际kpi
      actualList: [],
      //参考api
      consultList: [],
      kpiYearMontList: [],
      kpixdata: [],
      //温度湿度值
      // tempHum: {
      //   THTemp: 0,
      //   THHum: 0
      // },

      timesNow: new Date(),
      isElcActive: 0,
      isTHActive: 0,
      outisTHActive:0,
      Elcanimate: false,
      THanimate: false,
      outTHanimate:false,
      //电表设备列表
      ElcList: [],
      //温湿度设备列表
      THList: [],
      //室外温湿度计
      OutTHList:[],

      //电表实时数据
      ElcDataList: [],
      //温湿度实时数据
      THDataList: [],
      //室外实时数据
      OutTHDataList:[],
      WInsPowerState: "#00F23E", //仪表盘颜色
      TopHeight: {
        height: "",
      },
      BottomHeight: {
        height: "",
      },
      CenterHeight: {
        height: "",
      },
      ElcHeight: {
        height: "",
      },
      LeftHeight: {
        height: "",
        width: "100%",
      },
      tabHeight: {
        heihgt: "",
      },
      CenterBHeight: {
        height: "",
      },
      RealHeight: {
        height: "",
      },

      RightHeight: {
        height: "",
      },
      formselect: { labId: "" },
      greenStateText: "#fff",
      yellowStateText: "#FFE793",
      redStateText: "#FC9D81",
      greenState: ["#66DA51", "#00F23E"],
      yellowState: ["#FFE793", "#FBD44B"],
      redState: ["#FC9D81", "#FD4144"],
      THlev: 0,
      PUElev:"green",
      PueRealData:'',
      thtestLevList: [],
      Elc3: null,
      ElcTri: null,
      InsPower: null,
      NowPUE: null,
      LastPUE: null,
      Temperature: null,
      Humidity: null,
      subEname: "",
      subThname: "",
      //三相电流
      Echarts3ElcData: [
        {
          name: "a",
          value: 0,
          unit: "A",
          pos: ["16.6%", "50%"],
          range: [0, this.ratedCurrent], //刻度盘范围
          Tcolor: this.greenStateText,
        },
        {
          name: "b",
          value: 0,
          unit: "A",
          pos: ["49.8%", "50%"],
          range: [0, this.ratedCurrent],
          Tcolor: "",
        },
        {
          name: "c",
          value: 0,
          unit: "A",
          pos: ["83%", "50%"],
          range: [0, this.ratedCurrent],
          Tcolor: "",
        },
      ],

      optionElc3: {
        series: [],
      },
      //不平衡值
      TriData: [
        {
          name: " ",
          value: 0, //实时数值 百分比
          unit: "%",
          pos: ["50%", "55%"], //单位
          range: [0, 60], //刻度盘范围，阈值范围
          Tcolor: "",
        },
      ],

      optionElcTri: {
        series: [],
      },
      //功率
      optionInsPower: {
        title: "",
        series: [],
      },
      //温度
      optionTemperature: {
        title: "",
        graphic: [],
        series: [],
      },
      //湿度
      optionHumidity: {
        title: "",
        graphic: [],
        series: [],
      },
      EActiveTabs: "tab0",
      EActiveTabsValue: 0,
      ETabstimer: null, // tab自动切换定时器
      TActiveTabs: "tab0",
      TActiveTabsValue: 0,
      TTabstimer: null, // tab自动切换定时器

      outTActiveTabs: "tab0",
      outTActiveTabsValue: 0,
      outTTabstimer: null, // tab自动切换定时器
      LabNameTop: {
        //电表和温湿度表名称的位置高度
        top: "",
      },
      RealpueTimer:null,
      showOutTH:true,
      tempHumTimer:null,
    };
  },
  created() {
    this.allH();
    window.addEventListener("resize", this.allH);
    // setInterval(this.scrollElc1, 5000)
    // setInterval(this.scrollTH1, 5000)
  },
  methods: {
    RegionMyService(conn) {
      var that = this;
      GetMyRegionChainList().then((res) => {
        if (res.success) {
          var str = JSON.stringify(res.result);
          // console.log(str)
          str = str.replace(/cityList/g, "children");
          str = str.replace(/factoryList/g, "children");
          str = str.replace(/buildingList/g, "children");
          str = str.replace(/labList/g, "children");
          str = str.replace(/deviceList/g, "children");
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "label");
          this.data = JSON.parse(str);
          that.getCurrentPart(this.data);
          this.data = JSON.stringify(this.data);
          //console.log('-----------'+JSON.parse(this.data)[0].children[0].children[0].children[0].children[0].value);
          let lid = "";
          if (this.$route.params.value) {
            //console.log(this.$route.params.value);
            lid = this.$route.params.value;

          } else {
            var lasbuid = getCookie("colibid");
            lid = lasbuid;
            let model = JSON.parse(this.data)[0];
          }
          setCookie("currLabId",lid);
          this.currLabId= lid;
          this.getLabUserInfo(lid, conn);
          this.getPue(lid);
          this.getKpi(lid);
          this.getRealPue(lid);
          this.OutTempData(lid);
        } else {
          that.$message.error(this.$t('InterfaceRequestError'));
        }
      });
    },
    getCurrentPart(items) {
      items.map((i) => {
        if (i.children) {
          this.getCurrentPart(i.children);
        } else {
          delete i.children;
        }
      });
    },

    TimeSort(a, b) {
      return Date.parse(b.timestamp) - Date.parse(a.timestamp);
    },
    //电表各项数值
    ElcData(code) {
      this.Echarts3ElcData = null;
      this.optionElc3 = null;
      this.TriData = null;
      this.optionElcTri = null;
      this.optionInsPower = null;
      if (this.elclevList.length > this.ElcList.length * 5) {
        this.elclevList = [];
      }
      //取设备的额定电流 电压 阈值
      for (let k = 0; k < this.ElcList.length; k++) {
        if (this.ElcList[k].code == code) {
          this.ratedCurrent = this.ElcList[k].ratedCurrent;
          this.ratedVoltage = this.ElcList[k].ratedVoltage;
          this.magnification = this.ElcList[k].magnification;
          this.thridList = this.ElcList[k].typeValueList; //获取当前设备阈值
        }
      }

      //存前一分钟数据
      let message = [];
      let hash = [];
      //
      let m = "";
      let t = [];
      //排序 取最近时间数据
      this.ElcDataList.sort(this.TimeSort);
      //console.log("实时数据"+JSON.stringify(this.ElcDataList));
      //拿到每个设备的最近一条数据

      for (let n = 0; n < this.ElcDataList.length; n++) {
        for (let j = n + 1; j < this.ElcDataList.length; j++) {
          if (this.ElcDataList[n].dId === this.ElcDataList[j].dId) {
            let start1 = Date.parse(this.ElcDataList[n].timestamp);
            let end1 = Date.parse(this.ElcDataList[j].timestamp);
            if (start1 >= end1) {
              this.ElcDataList.splice(j, 1);
            }
          }
        }
        let asa = this.ElcDataList[n];
        hash.push(asa);
      }

      //清空缓存数据
      this.ElcDataList.splice(0, this.ElcDataList.length);
      this.ElcDataList = [];
      //console.log('清空：'+this.ElcDataList)
      t = hash;
      //给缓存赋值最近一组数据
      this.ElcDataList = t;
      //console.log('赋值后：'+ JSON.stringify(this.ElcDataList))
      if (this.ElcDataList.length > 0) {
        //先找出有没有前一分钟的数据 有替换，没有则添加
        this.ElcDataList.sort(this.TimeSort);

        //console.log(this.ElcDataList);
        for (var i = 0; i < this.ElcDataList.length; i++) {
          if (this.ElcDataList[i].dId == code) {
            //console.log('电表各项数值---'+JSON.stringify(this.ElcDataList[i]))
            message = this.ElcDataList[i];
            var iIdsList = message.iIds; //this.ElcDataList.find(v=>v.dId==message.dID)
            var indexa = iIdsList.findIndex((value) => value == "Ia");
            var indexb = iIdsList.findIndex((value) => value == "Ib");
            var indexc = iIdsList.findIndex((value) => value == "Ic");
            var indexw = iIdsList.findIndex((value) => value == "W");
            var a = message.iValues[indexa];
            var b = message.iValues[indexb];
            var c = message.iValues[indexc];
            var w = message.iValues[indexw];
            var imba = message.imbalenceIndex;
            let nottimestamp = message.timestamp;

            var iUnit = message.iUnits[indexw];
            if (iUnit == "W") {
              w = w / 1000;
            }

            let magnification = 1; //倍率
            let enableMultiply = false; //是否乘以倍率
            this.ElcList.map((i) => {
              if (i.code == code) {
                magnification = i.magnification;
                enableMultiply = i.enableMultiply;
              }
            });
            this.magnification = magnification;
            let Iavg = 0; //三相电力流平均值乘以倍率
            if (enableMultiply) {
              Iavg =
                (((parseFloat(a) + parseFloat(b) + parseFloat(c)) * 10000) /
                  30000) *
                magnification;
            } else {
              Iavg =
                ((parseFloat(a) + parseFloat(b) + parseFloat(c)) * 10000) /
                30000;
            }

            //判断是否有设置阈值
            //if(this.ElcList[0].typeValueList.length>0){
            if (this.thridList.length > 0) {
              // let wmodels = this.ElcList[0].typeValueList.find(a=>a.name=='W')
              // let amodels = this.ElcList[0].typeValueList.find(a=>a.name=='Ia')
              // let bmodels = this.ElcList[0].typeValueList.find(a=>a.name=='Ib')
              // let cmodels = this.ElcList[0].typeValueList.find(a=>a.name=='Ic')
              // let tmodels = this.ElcList[0].typeValueList.find(a=>a.name=='Imba')

              let wmodels = this.thridList.find((a) => a.name == "W");
              let amodels = this.thridList.find((a) => a.name == "Ia");
              let bmodels = this.thridList.find((a) => a.name == "Ib");
              let cmodels = this.thridList.find((a) => a.name == "Ic");
              let tmodels = this.thridList.find((a) => a.name == "Imba");
              let tcondion = this.thridList.find((a) => a.name == "ImbaC"); //三相不平衡电流条件阈值

              let wlev = this.CheckNotif(wmodels, w, nottimestamp, code);
              let alev = this.CheckNotif(amodels, a, nottimestamp, code);
              let blev = this.CheckNotif(bmodels, b, nottimestamp, code);
              let clev = this.CheckNotif(cmodels, c, nottimestamp, code);
              let three = this.CheckNotifImba(
                tmodels,
                imba,
                nottimestamp,
                tcondion,
                Iavg,
                code
              );

              //电流((ia+ib+ic)/3)>=额定电流*三相不平衡电流

              this.ratedCurrent * tmodels;
              //发送企微信取消注释
              // this.elclevList.push(wlev.levels);
              // this.elclevList.push(alev);
              // this.elclevList.push(blev);
              // this.elclevList.push(clev);
              if (this.elclevList.indexOf(wlev.levels) == -1) {
                let vmo = {
                  levels: wlev.levels,
                  code: wlev.code,
                };
                this.elclevList.push(vmo);
              }
              if (this.elclevList.indexOf(alev.levels) == -1) {
                let vmo = {
                  levels: alev.levels,
                  code: alev.code,
                };
                this.elclevList.push(vmo);
              }
              if (this.elclevList.indexOf(blev.levels) == -1) {
                let vmo = {
                  levels: blev.levels,
                  code: blev.code,
                };
                this.elclevList.push(vmo);
              }
              if (this.elclevList.indexOf(clev.levels) == -1) {
                let vmo = {
                  levels: clev.levels,
                  code: clev.code,
                };
                this.elclevList.push(vmo);
              }
              if (this.elclevList.indexOf(three.levels) == -1) {
                let vmo = {
                  levels: three.levels,
                  code: three.code,
                };
                this.elclevList.push(vmo);
              }
            }
            //默认三相不平衡固定值阈值判断
            // let tmodels = {
            //     upOne:0.4,
            //     upTwo:0.5,
            //     name:'imba',
            //     downOne:-1,
            //     downTow:-1
            // }
            // let three = this.CheckNotif(tmodels,imba,nottimestamp)
            // // this.elclevList.push(three);
            //
            // if(this.elclevList.indexOf(three.levels)==-1){
            //     this.elclevList.push(three.levels);
            // }

            //告警变色

            for (let t = 0; t < this.ElcList.length; t++) {
              for (let s = 0; s < this.elclevList.length; s++) {
                if (this.ElcList[t].code == this.elclevList[s].code) {
                  if (this.elclevList[s].levels == "1") {
                    this.ElcList[t].styleClass = "warning";
                  }
                  if (this.elclevList[s].levels == "2") {
                    this.ElcList[t].styleClass = "error";
                  }
                }
              }
            }
            let ilevel = Math.max.apply(
              Math,
              this.elclevList.map(function (o) {
                return o.levels;
              })
            );
            //console.log("告警级别列表"+JSON.stringify(this.reportList))
            if (ilevel == "0") {
              this.testlev = "0";
            }
            if (ilevel == "1") {
              this.testlev = "1";
            }
            if (ilevel == "2") {
              this.testlev = "2";
            }
            //this.NotifByWeChat(code);//告警发微信
            //根据code取倍率

            //电流值 功率是否乘以倍率
            // if(enableMultiply)
            // {
            //   this.Ia = a * magnification;
            //   this.Ib = b * magnification;
            //   this.Ic = c * magnification;

            // }else{
            //    this.Ia = a;
            //   this.Ib = b ;
            //   this.Ic = c ;

            // }

            // if (enableMultiply) {
            //   Iavg =
            //     (((parseFloat(a) + parseFloat(b) + parseFloat(c)) * 10000) /
            //       30000) *
            //     magnification;
            // } else {
            //   Iavg =
            //     ((parseFloat(a) + parseFloat(b) + parseFloat(c)) * 10000) /
            //     30000;
            // }
            this.Ia = a * magnification;
            this.Ib = b * magnification;
            this.Ic = c * magnification;
            this.W = w * magnification;
            this.imbalenceIndex = imba;
          }
        }
      }
      //测试
      //  this.elclevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'SHJQ-B6-PM-028'
      // })
      //   this.elclevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'SHJQ-B6-PM-001'
      // })
      //   this.elclevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'SHJQ-B6-PM-029'
      // })
      //   this.elclevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'SHJQ-B6-PM-030'
      // })
      //   this.elclevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'SHJQ-B6-PM-004'
      // })

      //   for(let t =0;t<this.ElcList.length;t++){
      //       for(let s = 0;s<this.elclevList.length;s++){
      //           if(this.ElcList[t].code ==this.elclevList[s].code){
      //               if(this.elclevList[s].levels =="1"){
      //                   this.ElcList[t].styleClass = "warning";
      //               }
      //               if(this.elclevList[s].levels =="2"){
      //                   this.ElcList[t].styleClass = "error";
      //               }
      //           }
      //       }
      //   }
      //   let ilevel = Math.max.apply(Math, this.elclevList.map(function(o) {return o.levels}))
      //       //console.log("告警级别列表"+JSON.stringify(this.reportList))
      //       if (ilevel == "0") {
      //         this.testlev = "0";
      //       }
      //       if (ilevel == "1") {
      //         this.testlev = "1";
      //       }
      //       if (ilevel == "2") {
      //         this.testlev = "2";
      //       }
      //   console.log( this.elclevList)
      // this.Ia = this.randomNum(1,10)
      // this.Ib = 502//this.randomNum(1,10)
      // this.testlev = ilevel;
      // this.Ic = this.randomNum(1,10)
      // this.W = this.randomNum(1,10)
      // let tmodels = this.thridList.find(a=>a.name=='Imba')
      // let tcondion = this.thridList.find(a=>a.name=='ImbaC') //三相不平衡电流条件阈值
      // if(this.thridList.length>0){
      //  this.imbalenceIndex =this.randomNum(1,10) /10
      // }
      //  let Iavg = (parseFloat(this.Ia)+parseFloat(this.Ib)+parseFloat(this.Ic))*10000/30000 //平均电流
      //  let three = this.CheckNotifImba(tmodels, this.imbalenceIndex,'',tcondion,Iavg)

      this.$nextTick(() => {
        this.Echarts3Elc();
        this.EchartsTri();
        this.EchartsInsPower();
      });
      message = [];
      hash = [];
      m = "";
      t = [];
    },

    //发送微信逻辑，
    NotifByWeChat(code) {
      let notilev = Math.max.apply(
        Math,
        this.elclevList.map((item) => {
          return item.levels;
        })
      );
      let ntime = "";
      let nname = "";
      let ress = "";
      this.elclevList.map((item) => {
        if (item.levels == notilev) {
          ntime = item.times;
          nname = item.name;
        }
      });
      this.ethLevel = notilev;
      //console.log("告警级别"+notilev)
      let weChatSendMoel = {
        deviceCode: "",
        notiLevel: 0,
        labName: this.labName,
        notiTime: ntime,
        notiName: nname,
        mobileNum: this.contactMobile,
      };
      let reportmodel = {
        notiLevel: notilev,
        deviceCode: code,
        deviceType: "",
        sendStatus: 0,
      };

      if (notilev == 0) {
      } else if (notilev == 1) {
        //this.imgurl = n_yellow;

        weChatSendMoel.deviceCode = code;
        weChatSendMoel.notiLevel = notilev;
        weChatSendMoel.labName = this.labName;
        weChatSendMoel.notiTime = ntime;
        weChatSendMoel.notiName = nname;

        if (this.reportList.length > 0) {
          let findmodel = this.reportList.find((a) => a.deviceCode == code);
          if (!findmodel) {
            this.reportList.push(reportmodel);
            if (reportmodel.sendStatus != 1) {
              reportmodel.sendStatus = 1;
              //SendWeChat(weChatSendMoel);
            }
          }
        } else {
          this.reportList.push(reportmodel);
          if (reportmodel.sendStatus != 1) {
            reportmodel.sendStatus = 1;
            //SendWeChat(weChatSendMoel);
          }
        }
      } else if (notilev == 2) {
        //this.imgurl = n_red;
        weChatSendMoel.deviceCode = code;
        weChatSendMoel.notiLevel = notilev;
        weChatSendMoel.labName = this.labName;
        weChatSendMoel.notiTime = ntime;
        weChatSendMoel.notiName = nname;
        if (this.reportList.length > 0) {
          let findmodel = this.reportList.find((a) => a.deviceCode == code);
          if (!findmodel) {
            this.reportList.push(reportmodel);
            if (reportmodel.sendStatus != 1) {
              reportmodel.sendStatus = 1;
              //SendWeChat(weChatSendMoel);
            }
          }
          //告警等级提升发微信
          if (findmodel && findmodel.notilev < notilev) {
            var codeindex = this.reportList.findIndex(
              (a) => a.deviceCode == code
            );
            this.reportList.splice(codeindex, 1);
            findmodel.deviceCode = code;
            findmodel.notilev = notilev;

            this.reportList.push(findmodel);
            if (reportmodel.sendStatus != 1) {
              reportmodel.sendStatus = 1;
              //SendWeChat(weChatSendMoel);
            }
          }
        } else {
          this.reportList.push(reportmodel);
          if (reportmodel.sendStatus != 1) {
            reportmodel.sendStatus = 1;
            //SendWeChat(weChatSendMoel);
          }
        }
        //console.log('告警级别'+notilev);
        //调企微
      } else {
        //this.imgurl = n_green;
      }
      this.elclevList = [];
      //console.log(this.reportList);
      let ilevel = Math.max.apply(
        Math,
        this.reportList.map((item) => {
          return item.notiLevel;
        })
      );
      //console.log("告警级别列表"+JSON.stringify(this.reportList))
      if (ilevel == "0") {
        this.testlev = "0";
      }
      if (ilevel == "1") {
        this.testlev = "1";
      }
      if (ilevel == "2") {
        this.testlev = "2";
      }
      //console.log("告警图片路径"+ this.testlev)
    },

    //温湿度数值
    TempHumdata(code) {
      //this.THDataList.push(message);
      this.THTemp = "";
      this.THHum = "";
      if (this.thtestLevList.length > this.THList.length ) {
        this.thtestLevList = [];
      }
      //this.THTemp = this.randomNum(10,40);
      //this.THHum = this.randomNum(10,72);
      for (let k = 0; k < this.THList.length; k++) {
        if (this.THList[k].name == code) {
          this.currTempTypeList = this.THList[k].typeValueList; //获取当前设备阈值
        }
      }
      //console.log(this.currTempTypeList)
      this.optionTemperature = null;
      this.optionHumidity = null;
      //存前一分钟数据
      let message = [];
      let hash = [];
      //
      let m = "";
      let t = [];
      this.THDataList.sort(this.TimeSort);

      for (let n = 0; n < this.THDataList.length; n++) {
        for (let j = n + 1; j < this.THDataList.length; j++) {
          if (this.THDataList[n].dId === this.THDataList[j].dId) {
            let start1 = Date.parse(this.THDataList[n].timestamp);
            let end1 = Date.parse(this.THDataList[j].timestamp);
            if (start1 >= end1) {
              this.THDataList.splice(j, 1);
            }
          }
        }
        let asa = this.THDataList[n];
        hash.push(asa);
      }
      this.THDataList.splice(0, this.THDataList.length);
      this.THDataList = [];
      //console.log('清空：'+this.ElcDataList)
      t = hash;
      //给缓存赋值最近一组数据
      this.THDataList = t;
      if (this.THDataList.length > 0) {
        this.THDataList.sort(this.TimeSort);

        //console.log('温度列表'+JSON.stringify(this.THDataList));

        for (var i = 0; i < this.THDataList.length; i++) {
          if (this.THDataList[i].dId == code) {
            //console.log('温湿度表---'+JSON.stringify(this.THDataList[i]))
            message = this.THDataList[i];
            if (message.iValues != null) {
              let temp = message.iValues[0];
              let hum = message.iValues[1];

              this.THTemp = temp;
              this.THHum = hum;
            }
          }
        }
      }

      let tUpOne = -1;
      let tUpTwo = -1;
      let tDownOne = -1;
      let tDownTwo = -1;

      let hUpOne = -1;
      let hUpTwo = -1;
      let hDownOne = -1;
      let hDownTwo = -1;

      let tempValue = this.currTempTypeList.find((a) => a.name == "Temp");
      let humValue = this.currTempTypeList.find((a) => a.name == "Hum");

      if (tempValue && humValue) {
        //温度
        tUpOne = tempValue.upOne;
        tUpTwo = tempValue.upTwo;
        tDownOne = tempValue.downOne;
        tDownTwo = tempValue.downTwo;
        //湿度
        hUpOne = humValue.upOne;
        hUpTwo = humValue.upTwo;
        hDownOne = humValue.downOne;
        hDownTwo = humValue.downTwo;
        //告警变色
        if (
          (parseFloat(this.THTemp) >= tUpTwo && tUpTwo !=-1)||
          (parseFloat(this.THTemp) <= tDownTwo && tDownTwo !=-1)
        ) {
          //变红
          if (this.thtestLevList.indexOf("2") == -1) {
            //this.thtestLevList.push("2");
            this.thtestLevList.push({
              levels: "2",
              code: code,
            });
          }
        } else if (
          (parseFloat(this.THTemp) >= tUpOne && tUpOne != -1) ||
          (parseFloat(this.THTemp) <= tDownOne && tDownOne != -1)
        ) {
          //变黄
          //先找有没有1 有 就不PUSH无就PUSH
          if (this.thtestLevList.indexOf("1") == -1) {
            this.thtestLevList.push({
              levels: "1",
              code: code,
            });
          }
        }
        if (
          (parseFloat(this.THHum) >= hUpTwo && hUpTwo !=-1 )||
          (parseFloat(this.THHum) <= hDownTwo && hDownTwo != -1)
        ) {
          //变红
          if (this.thtestLevList.indexOf("2") == -1) {
            this.thtestLevList.push({
              levels: "2",
              code: code,
            });
          }
        } else if (
          (parseFloat(this.THHum) >= hUpOne && hUpOne != -1) ||
          (parseFloat(this.THHum) <= hDownOne && hDownOne !=-1 )
        ) {
          //变黄
          //先找有没有1 有 就不PUSH无就PUSH
          if (this.thtestLevList.indexOf("1") == -1) {
            this.thtestLevList.push({
              levels: "1",
              code: code,
            });
          }
        }
      }

      //测试

      // this.thtestLevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'TempHum000613'
      // })
      // this.thtestLevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'TempHum000603'
      // })
      // this.THTemp = this.randomNum(1,10)
      // this.THHum = this.randomNum(1,10)

      for (let h = 0; h < this.THList.length; h++) {
        for (let s = 0; s < this.thtestLevList.length; s++) {
          if (this.THList[h].name == this.thtestLevList[s].code) {
            if (this.thtestLevList[s].levels == "1") {
              this.THList[h].styleClass = "warning";
            }
            if (this.thtestLevList[s].levels == "2") {
              this.THList[h].styleClass = "error";
              break;
            }
          }
        }
      }

      let ithlevels = Math.max.apply(
        Math,
        this.thtestLevList.map(function (o) {
          return o.levels;
        })
      );

      if (ithlevels == "0") {
        this.THlev = "0";
      }
      if (ithlevels == "1") {
        this.THlev = "1";
      }
      if (ithlevels == "2") {
        this.THlev = "2";
      }

      this.$nextTick(() => {
        this.EchartsTemperature();
        this.EchartsHumidity();
      });

      message = [];
      hash = [];
      m = "";
      t = [];
    },

    //室外温湿度
    OutTempHumdata(code) {
      //this.THDataList.push(message);
      this.outTHTemp = "";
      this.outTHHum = "";
      if (this.thtestLevList.length > this.OutTHList.length * 5) {
        this.thtestLevList = [];
      }
      // this.outTHTemp = this.randomNum(10,40);
      // this.outTHHum = this.randomNum(10,72);
      for (let k = 0; k < this.OutTHList.length; k++) {
        if (this.OutTHList[k].name == code) {
          this.outcurrTempTypeList = this.OutTHList[k].typeValueList; //获取当前设备阈值
        }
      }
      //console.log(this.currTempTypeList)
      //this.optionTemperature = null;
      //.optionHumidity = null;
      //存前一分钟数据
      let message = [];
      let hash = [];
      //
      let m = "";
      let t = [];
      this.OutTHDataList.sort(this.TimeSort);

      for (let n = 0; n < this.OutTHDataList.length; n++) {
        for (let j = n + 1; j < this.OutTHDataList.length; j++) {
          if (this.OutTHDataList[n].dId === this.OutTHDataList[j].dId) {
            let start1 = Date.parse(this.OutTHDataList[n].timestamp);
            let end1 = Date.parse(this.OutTHDataList[j].timestamp);
            if (start1 >= end1) {
              this.OutTHDataList.splice(j, 1);
            }
          }
        }
        let asa = this.OutTHDataList[n];
        hash.push(asa);
      }
      this.OutTHDataList.splice(0, this.OutTHDataList.length);
      this.OutTHDataList = [];
      //console.log('清空：'+this.ElcDataList)
      t = hash;
      //给缓存赋值最近一组数据
      this.OutTHDataList = t;
      if (this.OutTHDataList.length > 0) {
        this.OutTHDataList.sort(this.TimeSort);

        //console.log('温度列表'+JSON.stringify(this.THDataList));

        for (var i = 0; i < this.OutTHDataList.length; i++) {
          if (this.OutTHDataList[i].dId == code) {
            //console.log('温湿度表---'+JSON.stringify(this.THDataList[i]))
            message = this.OutTHDataList[i];
            if (message.iValues != null) {
              let temp = message.iValues[0];
              let hum = message.iValues[1];

              this.outTHTemp = temp;
              this.outTHHum = hum;
            }
          }
        }
      }
      if( this.outTHTemp && this.outTHHum){
        this.showOutTH = true
      }

      let tUpOne = -1;
      let tUpTwo = -1;
      let tDownOne = -1;
      let tDownTwo = -1;

      let hUpOne = -1;
      let hUpTwo = -1;
      let hDownOne = -1;
      let hDownTwo = -1;
       
      let tempValue = this.outcurrTempTypeList.find((a) => a.name == "Temp");
      let humValue = this.outcurrTempTypeList.find((a) => a.name == "Hum");
      if (tempValue && humValue) {
        //温度
        tUpOne = tempValue.upOne;
        tUpTwo = tempValue.upTwo;
        tDownOne = tempValue.downOne;
        tDownTwo = tempValue.downTwo;
        //湿度
        hUpOne = humValue.upOne;
        hUpTwo = humValue.upTwo;
        hDownOne = humValue.downOne;
        hDownTwo = humValue.downTwo;
        //告警变色
        if (
          (parseFloat(this.outTHTemp) >= tUpTwo && tUpTwo !=-1 )||
          (parseFloat(this.outTHTemp) <= tDownTwo && tDownTwo != -1)
        ) {
          //变红
          if (this.thtestLevList.indexOf("2") == -1) {
            //this.thtestLevList.push("2");
            this.thtestLevList.push({
              levels: "2",
              code: code,
            });
          }
        } else if (
          (parseFloat(this.outTHTemp) >= tUpOne && tUpOne != -1)||
          (parseFloat(this.outTHTemp) <= tDownOne && tDownOne != -1)
        ) {
          //变黄
          //先找有没有1 有 就不PUSH无就PUSH
          if (this.thtestLevList.indexOf("1") == -1) {
            this.thtestLevList.push({
              levels: "1",
              code: code,
            });
          }
        }
        if (
          (parseFloat(this.outTHHum) >= hUpTwo && hUpTwo != -1 )|| (parseFloat(this.outTHHum) <= hDownTwo && hDownTwo != -1)
        ) {
          //变红
          if (this.thtestLevList.indexOf("2") == -1) {
            this.thtestLevList.push({
              levels: "2",
              code: code,
            });
          }
        } else if (
          (parseFloat(this.outTHHum) >= hUpOne && hUpOne != -1) ||
          (parseFloat(this.outTHHum) <= hDownOne && hDownOne != -1)
        ) {
          //变黄
          //先找有没有1 有 就不PUSH无就PUSH
          if (this.thtestLevList.indexOf("1") == -1) {
            this.thtestLevList.push({
              levels: "1",
              code: code,
            });
          }
        }
      }

      //测试

      // this.thtestLevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'zktest-001'
      // })
      // this.thtestLevList.push({
      //     levels:this.randomNum(0,3),
      //     code:'zktest-001'
      // })


      for (let h = 0; h < this.OutTHList.length; h++) {
        for (let s = 0; s < this.thtestLevList.length; s++) {
          if (this.OutTHList[h].name == this.thtestLevList[s].code) {
            if (this.thtestLevList[s].levels == "1") {
              this.OutTHList[h].styleClass = "warning";
            }
            if (this.thtestLevList[s].levels == "2") {
              this.OutTHList[h].styleClass = "error";
              break;
            }
          }
        }
      }

      let ithlevels = Math.max.apply(
        Math,
        this.thtestLevList.map(function (o) {
          return o.levels;
        })
      );

      if (ithlevels == "0") {
        this.THlev = "0";
      }
      if (ithlevels == "1") {
        this.THlev = "1";
      }
      if (ithlevels == "2") {
        this.THlev = "2";
      }



      message = [];
      hash = [];
      m = "";
      t = [];
    },

    //获取设备列表
    async getLabUserInfo(labid, conn) {
      this.ElcList = [];
      this.THList = [];
      getLabScreenInfo(labid).then((res) => {
        if (res.success) {
          let labinfo = res.result;
          this.labName = labinfo.labName;
          this.contactName = labinfo.contactName;
          this.contactMobile = labinfo.contactMobile;
          this.targetUrl = labinfo.labPicUrl; //+"?sv=2020-02-10&ss=bfqt&srt=co&sp=rwdlacupx&se=2099-05-28T15:01:57Z&st=2021-05-28T07:01:57Z&spr=https,http&sig=1Mf%2F5fA4G5C4fNhzj9kJ0SZSjN0LuM2fueUHijliybE%3D";
          //console.log(labinfo.electricInfoList);

          let edata = labinfo.electricInfoList;
          for (let i = 0; i < edata.length; i++) {
            const newDevcie = {
              name: edata[i].deviceName,
              code: edata[i].deviceCode,
              typeValueList: edata[i].typeValueList, //阈值
              magnification: edata[i].magnification, //倍率
              ratedCurrent: edata[i].ratedCurrent, //额定电流
              ratedVoltage: edata[i].ratedVoltage, //额定电压
              enableMultiply: edata[i].enableMultiply, //是否乘以倍率
              active: false,
            };
            this.ElcList.push(newDevcie);
          }
          this.subEname = this.ElcList[0].name.substring(
            0,
            this.ElcList[0].name.lastIndexOf("-")
          );

          //console.log("电表："+JSON.stringify(this.ElcList))
          for (let k = 0; k < this.ElcList.length; k++) {
            connection.on(this.ElcList[k].code, (data) => {
              this.ElcDataList.push(data);
            });
          }

          this.ElcList.forEach((tem) => {
            tem.styleClass = "normal";
          });
          let odata = labinfo.otherDeviceList;
          for (let i = 0; i < odata.length; i++) {
            const newDevcie1 = {
              name: odata[i].deviceCode,
              code: odata[i].deviceName,
              typeValueList: odata[i].typeValueList, //阈值
              active: false,
            };
            //室内的

            if (odata[i].isOutdoor == false) {
              this.THList.push(newDevcie1);
            }
             //室外共享的
            if(odata[i].isOutdoor == true){
              this.OutTHList.push(newDevcie1)
            }

          }
          //console.log( this.OutTHList);

          if(this.THList.length>0){
            this.subThname = this.THList[0].code.substring(
              0,
              this.THList[0].code.lastIndexOf("-")
            );
          }

          this.THList.forEach((tem) => {
            tem.styleClass = "normal";
          });

          if (conn) {
            for (let k = 0; k < this.THList.length; k++) {
              connection.on(this.THList[k].name, (data) => {
                this.THDataList.push(data);
              });
            }

            connection
              .start()
              .then(() => console.log("ready"))
              .catch(console.error);
          }


          if (conn) {
            for (let k = 0; k < this.OutTHList.length; k++) {
              connection.on(this.OutTHList[k].name, (data) => {
                this.OutTHDataList.push(data);
              });
            }

            connection
              .start()
              .then(() => console.log("ready"))
              .catch(console.error);
          }
          // console.log("温湿度表："+this.THList)
          //console.log("实验室管理员信息"+JSON.stringify(data))
        }
        //console.log(this.ElcList)
        //console.log(this.THList)
        this.scrollElc(this.ElcList);
        this.scrollTH(this.THList);
        this.scrollTHOut(this.OutTHList);
      });
    },

    getYearMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      return `${year}${month}`;
    },
    //获取pue数据
    async getPue(labid) {
       
      this.formselect.labId = labid;
      var datas = this.formselect;
      let data = await GetEqPueData(datas);
      //console.log(data.result.value);
      var date = new Date();
      var lastym = "";
      var currym = "";
      var monthstr = "";
      if (date.getMonth() == 0) {
        currym = `${date.getFullYear()}${0}${date.getMonth() + 1}`;
        lastym = `${date.getFullYear() - 1}${12}`;
      } else if (date.getMonth() > 0 && date.getMonth() < 9) {
        monthstr = `${0}${date.getMonth() + 1}`;
        currym = `${date.getFullYear()}${monthstr}`;
        lastym = `${date.getFullYear()}${0}${date.getMonth()}`;
      } else if (date.getMonth() == 9) {
        monthstr = `${date.getMonth() + 1}`;
        currym = `${date.getFullYear()}${monthstr}`;
        lastym = `${date.getFullYear()}${0}${date.getMonth()}`;
      }
      else {
        lastym = `${date.getFullYear()}${date.getMonth()}`;
        currym = `${date.getFullYear()}${date.getMonth() + 1}`;
      }

      //let curmonth =
      //let lastmonth =
      data.result.value.map((i) => {
        if (i.yearMonth == lastym) {
          this.lastpue = i.pue;
          //console.log('pue1:'+this.lastpue)
        } else if (i.yearMonth == currym) {
          this.currpue = i.pue;
          //console.log('pue2:'+this.currpue)
        }
      });

      this.$nextTick(() => {
        this.EchartsNowPUE();
        this.EchartsLastPUE();
      });
    },
    async getRealPue(labid){
      this.formselect.labId = labid;
      var datas = this.formselect;

      clearInterval(this.RealpueTimer);
      this.RealpueTimer = null;
      GetRealPueData(datas).then((res) => {
          if (res.success) {
             
              let data =res.result;
              this.PUElev = data.alarmColer
              this.PueRealData = parseFloat(data.pueValue).toFixed(2)
              if(data.pueValue == ''){
                this.PueRealData ='TBD'
              }
          }
        });
      //温湿度表列的自动切换
      this.RealpueTimer = setInterval(() => {
        GetRealPueData(datas).then((res) => {
          if (res.success) {
             
              let data =res.result;
              this.PUElev = data.alarmColer
              this.PueRealData = parseFloat(data.pueValue).toFixed(2)
               if(data.pueValue == ''){
                this.PueRealData ='TBD'
              }
          }
        });
        //这里放当前数据
      }, 30000);
    },
    //获取kpi数据
    async getKpi(labid) {
      let mdata = [];
      this.actualList = [];
      this.consultList = [];
      this.kpiYearMontList = [];
      this.kpixdata = [];
      this.formselect.labId = labid;
      var datas = this.formselect;
      let data = await GetKpiData(datas);
      //console.log(data.result.value);
      mdata = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      for (let i = 0; i < data.result.value.length; i++) {
        this.actualList.push(parseInt(data.result.value[i].eq));
        this.consultList.push(parseInt(data.result.value[i].eqkpi));
        this.kpiYearMontList.push(data.result.value[i].yearMonth);
        if (data.result.value[i].yearMonth.substr(4, 2) === "01") {
          this.kpixdata.push(mdata[0]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "02") {
          this.kpixdata.push(mdata[1]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "03") {
          this.kpixdata.push(mdata[2]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "04") {
          this.kpixdata.push(mdata[3]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "05") {
          this.kpixdata.push(mdata[4]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "06") {
          this.kpixdata.push(mdata[5]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "07") {
          this.kpixdata.push(mdata[6]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "08") {
          this.kpixdata.push(mdata[7]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "09") {
          this.kpixdata.push(mdata[8]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "10") {
          this.kpixdata.push(mdata[9]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "11") {
          this.kpixdata.push(mdata[10]);
        }
        if (data.result.value[i].yearMonth.substr(4, 2) === "12") {
          this.kpixdata.push(mdata[11]);
        }
      }
      //console.log("年月"+ this.kpixdata)

      this.$nextTick(() => {
        this.EchartsElcKPI();
      });
    },
    changeTHLDevice(oldDevice, currDevice) {
      this.device = currDevice;
      //console.log(this.device);
      this.TempHumdata(currDevice);
      //connection.on(currDevice, this.TempHumdata);
    },

    changeOutTHLDevice(oldDevice, currDevice) {
      this.outdevice = currDevice;
      //console.log(this.device);
      this.OutTempHumdata(currDevice);
      //connection.on(currDevice, this.TempHumdata);
    },
    changeElcDevice(oldDevice, currDevice) {
      //console.log('上一个设备：'+oldDevice)
      this.elcdevice = currDevice;
      //console.log('当前的设备：'+this.elcdevice)
      this.ElcData(currDevice);
      //connection.on(currDevice, this.ElcData);
    },

    //电表设备滚动
    scrollElc(arr) {
      //电表列的自动切换
      clearInterval(this.ETabstimer);
      this.ETabstimer = null;

      this.ETabstimer = setInterval(() => {
        if (this.EActiveTabsValue >= arr.length) {
          this.EActiveTabsValue = 0;
          this.EActiveTabs = arr[0].name;
        } else {
          this.EActiveTabs = arr[this.EActiveTabsValue].name;
        }
        this.Elcanimate = true;
        //console.log("滚动电表"+this.ElcList)
        if (arr.length > 0) {
          this.thridList = [];

          this.WInsPowerState = this.greenState[1];
          this.Ia = "";
          this.Ib = "";
          this.Ic = "";
          this.W = "";
          this.imbalenceIndex = "";
          let currElcName = arr[this.EActiveTabsValue].code;
          let elcName = "";
          if (this.EActiveTabsValue === 0) {
            elcName = arr[arr.length - 1].code;
          } else {
            elcName = arr[this.EActiveTabsValue - 1].code;
          }
          //console.log('此设备编号：'+currElcName)
          this.changeElcDevice(elcName, currElcName);

          this.Elcanimate = false;
        }

        this.EActiveTabsValue += 1;

        //这里放当前数据
      }, 3000);
    },

    //温湿度设备滚动
    scrollTH(arr) {
        if(arr.length>0){
        clearInterval(this.TTabstimer);
        this.TTabstimer = null;
        //温湿度表列的自动切换
        this.TTabstimer = setInterval(() => {
        if (this.TActiveTabsValue >= arr.length) {
          this.TActiveTabsValue = 0;
          this.TActiveTabs = arr[0].name;
        } else {
          this.TActiveTabs = arr[this.TActiveTabsValue].name;
        }

        this.THanimate = true;
        //console.log("滚动温湿度表"+this.THList)
        this.isTHActive = index;
        if (arr.length > 0) {
          this.currTempTypeList = [];
          this.currHumTypeList = [];
          // this.THHum =''
          // this.THTemp =''

          if (arr.length > 0) {
            let oldTHLName = "";

            if (this.TActiveTabsValue === 0) {
              oldTHLName = arr[arr.length - 1].name;
            } else {
              oldTHLName = arr[this.TActiveTabsValue - 1].name;
            }
            let THLName = this.THList[this.TActiveTabsValue].name;
            this.changeTHLDevice(oldTHLName, THLName);
            //this.THList.shift();
            this.THanimate = false;
          }
        }
        this.TActiveTabsValue += 1;
        //这里放当前数据
      }, 3000);
      }
    },

    //室外温湿度计滚动
    scrollTHOut(arr) {
      clearInterval(this.outTTabstimer);
      this.outTTabstimer = null;
      //温湿度表列的自动切换
      if(arr.length>0){
        this.outTTabstimer = setInterval(() => {
        if (this.outTActiveTabsValue >= arr.length ) {
          this.outTActiveTabsValue = 0;
          this.outTActiveTabs = arr[0].name;
        } else {
          this.outTActiveTabs = arr[this.outTActiveTabsValue].name;
        }

        this.outTHanimate = true;
        //console.log("滚动温湿度表"+this.THList)
        this.outisTHActive = index;
        if (arr.length > 0) {
          this.outcurrTempTypeList = [];
          this.outcurrHumTypeList = [];
          // this.THHum =''
          // this.THTemp =''

          if (arr.length > 0) {
            let oldTHLName = "";

            if (this.outTActiveTabsValue === 0) {
              oldTHLName = arr[arr.length - 1].name;
            } else {
              oldTHLName = arr[this.outTActiveTabsValue - 1].name;
            }
            let THLName = this.OutTHList[this.outTActiveTabsValue].name;
            this.changeOutTHLDevice(oldTHLName, THLName);
            //this.THList.shift();
            this.outTHanimate = false;
          }
        }
        this.outTActiveTabsValue += 1;
        //这里放当前数据
      }, 3000);
      }
    },

    allH() {
      this.TopHeight.height = (window.innerHeight - 190) / 3 - 24 + "px";

      this.CenterHeight.height = (window.innerHeight - 190) / 3 + 5 + "px";
      this.CenterBHeight.height = (window.innerHeight - 190) / 3 - 21 + "px";

      this.BottomHeight.height = (window.innerHeight - 190) / 3 + "px";

      this.ElcHeight.height = (window.innerHeight - 190) / 3 + 15 + "px";
      // this.LeftHeight.height = (window.innerHeight - 190) / 3 / 2 + 30 + "px";

      this.tabHeight.height = (window.innerHeight - 190) / 3 + 94 + "px";
      this.LeftHeight.height = (window.innerHeight - 190) / 3 + 45 - 39 + "px";

      this.RightHeight.height = (window.innerHeight - 190) / 3 + 45 - 40 + "px";

      this.LabNameTop.top = (window.innerWidth * 13.68 - 985) / 130 + 12 + "px";
    },
    //三相电流
    Echarts3Elc() {
      if (this.Elc3) {
        this.Elc3.clear();
      }

      let Ianotif = 0;
      let Ibnotif = 0;
      let Icnotif = 0;
      let anofitone = 0;
      let anofittwo = 0;
      let bnofitone = 0;
      let bnofittwo = 0;
      let cnofitone = 0;
      let cnofittwo = 0;
      //拿阈值 this.thridList
      //let ElcListss = this.ElcList[0]
      let ElcListss = this.thridList;
      if (ElcListss) {
        // Ianotif = this.ElcList[0].typeValueList.find(a=>a.name=='Ia')
        // Ibnotif = this.ElcList[0].typeValueList.find(a=>a.name=='Ib')
        // Icnotif = this.ElcList[0].typeValueList.find(a=>a.name=='Ic')
        Ianotif = this.thridList.find((a) => a.name == "Ia");
        Ibnotif = this.thridList.find((a) => a.name == "Ib");
        Icnotif = this.thridList.find((a) => a.name == "Ic");
        if (Ianotif && Ibnotif && Icnotif) {
          anofitone =
            (Ianotif.upOne * this.magnification) /
            parseFloat(this.ratedCurrent);
          anofittwo =
            (Ianotif.upTwo * this.magnification) /
            parseFloat(this.ratedCurrent);
          bnofitone =
            (Ibnotif.upOne * this.magnification) /
            parseFloat(this.ratedCurrent);
          bnofittwo =
            (Ibnotif.upTwo * this.magnification) /
            parseFloat(this.ratedCurrent);
          cnofitone =
            (Icnotif.upOne * this.magnification) /
            parseFloat(this.ratedCurrent);
          cnofittwo =
            (Icnotif.upTwo * this.magnification) /
            parseFloat(this.ratedCurrent);
        }
      }
      var highlight = "#5F81C9";

      var greenState = this.greenState[1];
      var yellowState = this.yellowState[1];
      var redState = this.redState[1];
      var textColor = this.greenStateText;

      this.Echarts3ElcData = [
        {
          name: "a",
          value: parseFloat(this.Ia).toFixed(2),
          unit: "A",
          pos: ["16.6%", "50%"],
          range: [0, this.ratedCurrent], //刻度盘范围
          Tcolor: textColor,
        },
        {
          name: "b",
          value: parseFloat(this.Ib).toFixed(2),
          unit: "A",
          pos: ["49.8%", "50%"],
          range: [0, this.ratedCurrent],
          Tcolor: textColor,
        },
        {
          name: "c",
          value: parseFloat(this.Ic).toFixed(2),
          unit: "A",
          pos: ["83%", "50%"],
          range: [0, this.ratedCurrent],
          Tcolor: textColor,
        },
      ];

      var result = [];

      this.Echarts3ElcData.forEach(function (item) {
        let colorsmodel = [
          [0.3, greenState],
          [0.7, yellowState],
          [1, redState],
        ];

        if (ElcListss && Ianotif && Ibnotif && Icnotif) {
          if (item.name == "a") {
            colorsmodel = [];
            colorsmodel = [
              [anofitone, greenState],
              [anofittwo, yellowState],
              [1, redState],
            ];
          }
          if (item.name == "b") {
            colorsmodel = [];
            colorsmodel = [
              [bnofitone, greenState],
              [bnofittwo, yellowState],
              [1, redState],
            ];
          }
          if (item.name == "c") {
            colorsmodel = [];
            colorsmodel = [
              [cnofitone, greenState],
              [cnofittwo, yellowState],
              [1, redState],
            ];
          }
        }
        result.push(
          // 外围刻度
          {
            type: "gauge",
            center: item.pos,
            radius: "33.33%", // 1行3个
            splitNumber: item.splitNum || 6,
            min: item.range[0],
            max: item.range[1],
            startAngle: 215,
            endAngle: -35,
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                shadowBlur: 0,
                color: [
                  [0.3, highlight],
                  [0.7, highlight],
                  [1, highlight],
                ],
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
                width: 2,
              },
              length: -5,
              splitNumber: 5,
            },
            splitLine: {
              show: true,
              length: -10,
              lineStyle: {
                color: highlight,
              },
            },
            axisLabel: {
              distance: -20,
              textStyle: {
                color: "#C1C5CE",
                fontSize: "11",
              },
              formatter: function (v) {
                return v.toFixed(0);
              },
            },
            pointer: {
              show: 0,
            },
            detail: {
              show: 0,
            },
          },

          // 内侧指针、数值显示
          {
            name: item.name,
            type: "gauge",
            center: item.pos,
            radius: "30.33%",
            startAngle: 215,
            endAngle: -35,
            min: item.range[0],
            max: item.range[1],
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,

                color: colorsmodel,
              },
            },
            axisTick: {
              show: 0,
            },
            splitLine: {
              show: 0,
            },
            axisLabel: {
              show: 0,
            },
            pointer: {
              show: true,
              length: "80%",
              width: 4,
            },
            detail: {
              show: true,
              offsetCenter: [0, "220%"],
              textStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: item.Tcolor,
              },
              formatter:
                item.value +
                (item.unit || "") +
                "\n" +
                "{name1|I }{name2|" +
                item.name +
                "}",
              rich: {
                name: {
                  fontSize: 14,
                  lineHeight: 30,
                  color: "#ddd",
                  fontFamily: "Times New Roman",
                  fontWeight: "bold",
                },
                name2: {
                  fontSize: 12,
                  lineHeight: 10,
                  verticalAlign: "bottom",
                  color: "#ddd",
                  fontFamily: "Times New Roman",
                  fontWeight: "normal",
                },
              },
            },

            data: [
              {
                value: item.value,
              },
            ],
          }
        );
      });

      this.optionElc3 = {
        series: result,
      };

      this.Elc3.setOption(this.optionElc3);
    },
    //三相不平衡
    EchartsTri() {
      if (this.ElcTri) {
        this.ElcTri.clear();
      }

      var highlight = "#5F81C9";

      var greenState = this.greenState[1];
      var yellowState = this.yellowState[1];
      var redState = this.redState[1];
      var textColor = this.greenStateText;

      //拿阈值
      let Imbanotif = 0;
      let imbaUpOne = 0;
      let imbaUpTwo = 0;
      let ElcListss = this.thridList;
      if (ElcListss) {
        Imbanotif = this.thridList.find((a) => a.name == "Imba");

        if (Imbanotif) {
          if (Imbanotif.upOne != -1) {
            imbaUpOne = Imbanotif.upOne;
          }
          if (Imbanotif.upTwo != -1) {
            imbaUpTwo = Imbanotif.upTwo;
          }
        }
      }
      this.TriData = [
        {
          name: " ",
          value: parseFloat(this.imbalenceIndex * 100).toFixed(2), //实时数值 百分比
          unit: "%",
          pos: ["50%", "48%"], //单位
          range: [0, 60], //刻度盘范围，阈值范围
          Tcolor: textColor,
        },
      ];

      var result = [];

      this.TriData.forEach(function (item) {
        let colorsmodel = [
          [40 / 60, greenState],
          [50 / 60, yellowState],
          [100 / 60, redState],
        ];

        if (ElcListss && Imbanotif) {
          if (Imbanotif.upOne != -1 && Imbanotif.upTwo != -1) {
            colorsmodel = [];
            colorsmodel = [
              [imbaUpOne / 60, greenState],
              [imbaUpTwo / 60, yellowState],
              [100 / 60, redState],
            ];
          }
        }
        result.push(
          // 外围刻度
          {
            type: "gauge",
            center: item.pos,
            radius: "50%", // 1行3个
            splitNumber: item.splitNum || 6,
            min: item.range[0],
            max: item.range[1],
            startAngle: 215,
            endAngle: -35,
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                shadowBlur: 0,
                color: [
                  [0.3, highlight],
                  [0.7, highlight],
                  [1, highlight],
                ],
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
                width: 2,
              },
              length: -8,
              splitNumber: 5,
            },
            splitLine: {
              show: true,
              length: -15,
              lineStyle: {
                color: "#5A8BC9",
              },
            },
            axisLabel: {
              distance: -15,
              textStyle: {
                color: "#C1C5CE",
                fontSize: "12",
              },
            },
            pointer: {
              show: 0,
            },
            detail: {
              show: 0,
            },
          },

          // 内侧指针、数值显示
          {
            name: item.name,
            type: "gauge",
            center: item.pos,
            radius: "50%",
            startAngle: 215,
            endAngle: -35,
            min: item.range[0],
            max: item.range[1],
            axisLine: {
              show: true,
              lineStyle: {
                width: 5,
                color: colorsmodel,
                // [
                //     [10/60, greenState],//黄色警报刻度盘起始位置 百分比=阈值/刻度最大值
                //     [20/60, yellowState],
                //     [100/60, redState],
                // ],
              },
            },
            axisTick: {
              show: 0,
            },
            splitLine: {
              show: 0,
            },
            axisLabel: {
              show: 0,
            },
            pointer: {
              show: true,
              length: "80%",
              width: 4,
            },
            detail: {
              show: true,
              offsetCenter: [0, "160%"],
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: item.Tcolor,
              },
              formatter: ["{value} " + (item.unit || "")].join("\n"),
              rich: {
                name: {
                  fontSize: 12,
                  lineHeight: 20,
                  color: "#ddd",
                },
              },
            },

            data: [
              {
                value: item.value,
              },
            ],
          }
        );
      });

      this.optionElcTri = {
        series: result,
      };

      this.ElcTri.setOption(this.optionElcTri);
    },
    //瞬时总功率
    EchartsInsPower() {
      if (this.InsPower) {
        this.InsPower.clear();
      }

      let sss = (3 * this.ratedVoltage * this.ratedCurrent) / 1000;
      let value = parseFloat(this.W).toFixed(2);
      var greenState = this.greenState[1];
      var yellowState = this.yellowState[1];
      var redState = this.redState[1];
      var textColor = this.greenStateText;
      //this.WInsPowerState = greenState;//this.greenState[1];
      // this.imgurl = n_green;
      let title = "W ";

      let ElcListss = this.ElcList[0];

      this.optionInsPower = {
        title: {
          text: "{a|" + value + "}",
          x: "center",
          y: "bottom",
          textStyle: {
            rich: {
              a: {
                fontSize: 18,
                color: textColor,
                fontWeight: "bold",
                height: 45,
              },
            },
          },
        },
        series: [
          {
            type: "gauge",
            radius: "65%",
            clockwise: true,
            startAngle: "90",
            endAngle: "-269.9999",
            splitNumber: 20,

            center: ["50%", "45%"],
            detail: {
              offsetCenter: ["5%", "5%"],
              formatter: "KW ",
              fontSize: 20,
              color: "#fff",
            },
            pointer: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: [
                  [0, "#fff"],
                  [
                    value /
                      ((3 * this.ratedVoltage * this.ratedCurrent) / 1000),
                    this.WInsPowerState,
                  ], //取阈值上限
                  [1, "rgba(84,115,179,0.5)"],
                ],
                width: 30,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              length: 32,
              lineStyle: {
                color: "#1B2D47",
                width: 5,
              },
            },
            axisLabel: {
              show: false,
            },
          },
          {
            type: "pie",
            name: "W",
            radius: ["45%", "45%"],
            center: ["50%", "45%"],
            hoverAnimation: false,
            clockWise: false,
            itemStyle: {
              normal: {
                color: "#5F7EB7",
              },
            },
            label: {
              show: true,
              position: "center",
              fontSize: "30",
              color: "#fff",
              fontWeight: "bold",
            },

            labelLine: {
              show: false,
            },
            data: [100],
          },
          //{
          //    type: 'pie',
          //    name: '内层环',
          //    radius: [0, '40%'],
          //    center: ['50%', '40%'],
          //    hoverAnimation: false,
          //    clockWise: false,
          //    itemStyle: {
          //        normal: {
          //            color: '#21407E'
          //        }
          //    },
          //    label: {
          //        show: false,
          //    },
          //    data: [100]
          //}
        ],
      };
      this.InsPower.setOption(this.optionInsPower);
    },
    //用电量KPI
    EchartsElcKPI() {
      //var xdata = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
      var xdata = this.kpixdata;
      //console.log("dasd"+xdata)
      var ydata = this.actualList; //[23180, 22287.8, 23271, 22380, 25366, 27380, 25280, 22271, 21480, 25366, 9100, 0];

      var optionElcKPI = {
        legend: {
          data: ["Plan", "Actual"],
          left: 10,
          top: 5,
          itemWidth: 20,
          itemHeight: 5,
          textStyle: {
            color: "#999",
          },
        },
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        grid: {
          left: "20",
          right: "15",
          bottom: "5",
          top: "40",

          containLabel: true,
          z: 22,
        },
        xAxis: [
          {
            type: "category",
            gridIndex: 0,
            data: xdata,
            axisLine: {
              lineStyle: {
                color: "#0c3b71",
              },
            },
            axisLabel: {
              show: true,
              color: "rgb(170,170,170)",
              fontSize: 10,
              interval: 0,
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ["rgba(250,250,250,0)", "rgba(152,157,164,0.1)"],
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            gridIndex: 0,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },

            axisLine: {
              lineStyle: {
                color: "#0c3b71",
              },
            },
            axisLabel: {
              color: "rgb(170,170,170)",
              formatter: "{value} ",
            },
          },
        ],
        series: [
          {
            name: "Plan",
            type: "bar",
            barWidth: "25%",
            //barGap: '-135%',
            data: this.consultList, //[25500, 25200, 24500, 22600, 27300, 21300, 22500, 22270, 28530, 23630, 23600, 21300],
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#5076FA",
                  },
                  {
                    offset: 0.5,
                    color: "#46529D",
                  },
                  {
                    offset: 1,
                    color: "#2C3B79",
                  },
                ]),
              },
            },
          },
          {
            name: "Actual",
            type: "bar",
            barWidth: "25%",
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#46FF8B",
                  },
                  {
                    offset: 0.5,
                    color: "#08C158",
                  },
                  {
                    offset: 1,
                    color: "#0F7C48",
                  },
                ]),
              },
            },
            data: ydata,
          },
        ],
      };

      this.ElcKPI.setOption(optionElcKPI);
    },

    //本月PUE
    EchartsNowPUE() {
      var greenState = this.greenState[1];
      var yellowState = this.yellowState[1];
      var redState = this.redState[1];
      var textColor = this.greenStateText;
      var dataArr = 0;

      if (this.currpue == -1 || this.currpue == "") {
        dataArr = this.currpue = "TBD";
      } else {
        dataArr = parseFloat(this.currpue).toFixed(2);
      }

      var colorSet = greenState;
      var optionNowPUE = {
        xAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },

        series: [
          // 内圆
          {
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "50%"],
            z: 4,
            hoverAnimation: false,
            data: [
              {
                name: "PUE",
                value: dataArr,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "rgba(42,173,197,.5)",
                      },
                      {
                        offset: 1,
                        color: "rgba(42,173,197,0.1) ",
                      },
                    ]),
                  },
                },
                label: {
                  normal: {
                    color: textColor,
                    align: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                    formatter: "{a|" + dataArr + "}",
                    rich: {
                      title: {
                        fontSize: 12,
                        color: "#fff",
                        lineHeight: 22,
                      },
                      a: {
                        fontSize: 18,
                        color: textColor,
                        fontWeight: "bold",
                      },
                    },
                    position: "center",
                    show: true,
                  },
                },
                labelLine: {
                  show: false,
                },
              },
            ],
          },
          {
            name: this.$t('InternalProgressBar'),
            type: "gauge",
            center: ["50%", "50%"],
            radius: "65%",
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                color: [
                  [dataArr / 10, colorSet],
                  [1, "#2AADC5"],
                ],
                width: 5,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            itemStyle: {
              show: false,
            },
            detail: {
              show: false,
            },
            label: {
              show: false,
            },
            title: {
              //标题
              show: false,
            },
            data: [
              {
                name: "title",
                value: dataArr,
              },
            ],
            pointer: {
              show: false,
            },
          },
          // 刻度
          {
            type: "gauge",
            radius: "75%",
            center: ["50%", "50%"],
            startAngle: 220,
            endAngle: -40,
            z: 2,
            axisTick: {
              show: true,
              lineStyle: {
                color: "#6B9DD7",
                width: 1,
              },
              length: -8,
            }, //刻度样式
            splitLine: {
              show: true,
              lineStyle: {
                color: "#6B9DD7",
                width: 1,
              },
              length: -8,
            }, //分隔线样式
            axisLabel: {
              color: "rgba(255,255,255,0)",
              fontSize: 12,
            }, //刻度节点文字颜色
            pointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            label: {
              show: false,
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              color: "#fff",
              formatter: function (params) {
                return " ";
              },
              textStyle: {
                fontSize: 16,
              },
            },
          },
          // 外一层圈
          {
            type: "pie",
            radius: "65%",
            startAngle: 220,
            endAngle: -40,
            hoverAnimation: false,
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 1,
              },
            ],
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(42,173,197,.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(42,173,197,.1)",
                    },
                  ],
                },
              },
            },
          },
        ],
      };

      this.NowPUE.setOption(optionNowPUE);
    },
    //上月PUE
    EchartsLastPUE() {
      var greenState = this.greenState[1];
      var yellowState = this.yellowState[1];
      var redState = this.redState[1];
      var textColor = this.greenStateText;

      var dataArr = 0;

      if (this.lastpue == -1 || this.lastpue == "") {
        dataArr = this.lastpue = "TBD";
      } else {
        dataArr = parseFloat(this.lastpue).toFixed(2);
      }
      var colorSet = greenState;
      var optionLastPUE = {
        xAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },

        series: [
          // 内圆
          {
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "50%"],
            z: 4,
            hoverAnimation: false,
            data: [
              {
                name: "PUE",
                value: dataArr,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "rgba(42,173,197,.5)",
                      },
                      {
                        offset: 1,
                        color: "rgba(42,173,197,0.1) ",
                      },
                    ]),
                  },
                },
                label: {
                  normal: {
                    color: textColor,
                    align: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                    formatter: "{a|" + dataArr + "}",
                    rich: {
                      title: {
                        fontSize: 12,
                        color: "#fff",
                        lineHeight: 22,
                      },
                      a: {
                        fontSize: 18,
                        color: textColor,
                        fontWeight: "bold",
                      },
                    },
                    position: "center",
                    show: true,
                  },
                },
                labelLine: {
                  show: false,
                },
              },
            ],
          },
          {
            name: this.$t('InternalProgressBar'),
            type: "gauge",
            center: ["50%", "50%"],
            radius: "65%",
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                color: [
                  [dataArr / 10, colorSet],
                  [1, "#2AADC5"],
                ],
                width: 5,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            itemStyle: {
              show: false,
            },
            detail: {
              show: false,
            },
            label: {
              show: false,
            },
            title: {
              //标题
              show: false,
            },
            data: [
              {
                name: "title",
                value: dataArr,
              },
            ],
            pointer: {
              show: false,
            },
          },
          // 刻度
          {
            type: "gauge",
            radius: "75%",
            center: ["50%", "50%"],
            startAngle: 220,
            endAngle: -40,
            z: 2,
            axisTick: {
              show: true,
              lineStyle: {
                color: "#6B9DD7",
                width: 1,
              },
              length: -8,
            }, //刻度样式
            splitLine: {
              show: true,
              lineStyle: {
                color: "#6B9DD7",
                width: 1,
              },
              length: -8,
            }, //分隔线样式
            axisLabel: {
              color: "rgba(255,255,255,0)",
              fontSize: 12,
            }, //刻度节点文字颜色
            pointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            label: {
              show: false,
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              color: "#fff",
              formatter: function (params) {
                return " ";
              },
              textStyle: {
                fontSize: 16,
              },
            },
          },
          // 外一层圈
          {
            type: "pie",
            radius: "65%",
            startAngle: 220,
            endAngle: -40,
            hoverAnimation: false,
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 1,
              },
            ],
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(42,173,197,.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(42,173,197,.1)",
                    },
                  ],
                },
              },
            },
          },
        ],
      };

      this.LastPUE.setOption(optionLastPUE);
    },
    //温度
    EchartsTemperature() {
      if (this.Temperature) {
        this.Temperature.clear();
      }
      var greenState = this.greenState;
      var yellowState = this.yellowState;
      var redState = this.redState;
      var TempState = greenState;
      let tempValue = "";
      let tUpOne = -1;
      let tUpTwo = -1;
      let tDownOne = -1;
      let tDownTwo = -1;

      tempValue = this.currTempTypeList.find((a) => a.name == "Temp");
      let currTemp = parseFloat(this.THTemp);
      if (tempValue) {
        tUpOne = tempValue.upOne;
        tUpTwo = tempValue.upTwo;
        tDownOne = tempValue.downOne;
        tDownTwo = tempValue.downTwo;
        if (
          ((currTemp >= tUpOne && tUpOne != -1) && (currTemp <= tUpTwo && tUpTwo != -1)) ||
          ((currTemp >= tDownTwo && tDownOne != -1 ) && (currTemp <= tDownOne && tDownOne != -1))
        ) {
          TempState = yellowState;
        }
        if ((currTemp >= tUpTwo && tUpTwo != -1) || (currTemp <= tDownTwo && tDownTwo != -1)) {
          TempState = redState;
        }
      }

      var text = this.THTemp + "℃";
      this.optionTemperature = {
        title: {
          text: "",
          textStyle: {
            fontSize: 16,
            fontFamily: "Microsoft Yahei",
            fontWeight: "normal",
            color: "#ddd",
          },
          x: "center",
          y: "45%",
        },
        graphic: [
          {
            type: "group",
            left: "center",
            top: "45%",
            children: [
              {
                type: "text",
                z: 100,
                left: "center",
                top: "25",
                style: {
                  fill: "#fff",
                  text: text,
                  font: "16px Microsoft YaHei",
                },
              },
            ],
          },
        ],
        series: [
          {
            type: "liquidFill",
            data: [
              0.6,
              {
                value: this.THTemp / 100, //取阈值
                direction: "left",
                itemStyle: {
                  normal: {
                    color: TempState[0],
                  },
                },
              },
              0.4,
              0.3,
            ],
            radius: "60%",
            shape: "roundRect",
            center: ["50%", "45%"],
            backgroundStyle: {
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.4)",
              shadowBlur: 20,
              color: {
                type: "linear",
                x: 1,
                y: 0,
                x2: 0.5,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(68, 145, 253, 0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(68, 145, 253, .25)",
                  },
                  {
                    offset: 0,
                    color: "rgba(68, 145, 253, 0.5)",
                  },
                ],
                globalCoord: false,
              },
            },

            waveAnimation: false, // 禁止左右波动

            label: {
              normal: {
                //此处没有生效，本地生效

                formatter: "",
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 1,
                  color: TempState[1],
                },
                {
                  offset: 0,
                  color: TempState[0],
                },
              ],
              globalCoord: false,
            },
            outline: {
              show: false,
            },
          },
        ],
      };

      this.Temperature.setOption(this.optionTemperature);
    },
    //湿度
    EchartsHumidity() {
      if (this.Humidity) {
        this.Humidity.clear();
      }
      var greenState = this.greenState;
      var yellowState = this.yellowState;
      var redState = this.redState;

      var HumidityState = greenState;
      let humValue = "";
      let hUpOne = -1;
      let hUpTwo = -1;
      let hDownOne = -1;
      let hDownTwo = -1;
      humValue = this.currTempTypeList.find((a) => a.name == "Hum");
      let currHum = parseFloat(this.THHum);
      if (humValue) {
        hUpOne = humValue.upOne;
        hUpTwo = humValue.upTwo;
        hDownOne = humValue.downOne;
        hDownTwo = humValue.downTwo;
        if (
          ((currHum >= hUpOne && hUpOne != -1) && (currHum <= hUpTwo && hUpTwo != -1)) ||
          ((currHum >= hDownTwo && hDownTwo != -1) && (currHum <= hDownOne && hDownOne != -1))
        ) {
          HumidityState = yellowState;
        }
        if ((currHum >= hUpTwo && hUpTwo != -1) || (currHum <= hDownTwo && hDownOne != -1)) {
          HumidityState = redState;
        }
      }

      var text = this.THHum + "%";
      this.optionHumidity = {
        title: {
          text: "",
          textStyle: {
            fontSize: 16,
            fontFamily: "Microsoft Yahei",
            fontWeight: "normal",
            color: "#ddd",
          },
          x: "center",
          y: "45%",
        },
        graphic: [
          {
            type: "group",
            left: "center",
            top: "45%",
            children: [
              {
                type: "text",
                z: 100,
                left: "center",
                top: "25",
                style: {
                  fill: "#fff",
                  text: text,
                  font: "16px Microsoft YaHei",
                },
              },
            ],
          },
        ],
        series: [
          {
            type: "liquidFill",
            data: [
              0.6,
              {
                value: this.THHum / 100,
                direction: "left",
                itemStyle: {
                  normal: {
                    color: HumidityState[0],
                  },
                },
              },
              0.4,
              0.3,
            ],
            radius: "60%",
            shape: "roundRect",
            center: ["50%", "45%"],
            backgroundStyle: {
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.4)",
              shadowBlur: 20,
              color: {
                type: "linear",
                x: 1,
                y: 0,
                x2: 0.5,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(68, 145, 253, 0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(68, 145, 253, .25)",
                  },
                  {
                    offset: 0,
                    color: "rgba(68, 145, 253, 0.5)",
                  },
                ],
                globalCoord: false,
              },
            },

            waveAnimation: false, // 禁止左右波动

            label: {
              normal: {
                //此处没有生效，本地生效

                formatter: "",
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 1,
                  color: HumidityState[1],
                },
                {
                  offset: 0,
                  color: HumidityState[0],
                },
              ],
              globalCoord: false,
            },
            outline: {
              show: false,
            },
          },
        ],
      };

      this.Humidity.setOption(this.optionHumidity);
    },
    //报警逻辑
    CheckNotif(tmodels, value, nottimestamp, code) {
      let upone = ""; //上限一级
      let uptwo = ""; //上限二级
      let downone = ""; //下限一级
      let downtwo = ""; //下限二级
      let levels = 0;
      let newResult = {};
      var numReg = /^[0-9]*$/;
      var floatReg = /^[0-9]+\.?[0-9]+?$/;
      var numRe = new RegExp(numReg);
      var floatRe = new RegExp(floatReg);
      if (tmodels) {
        //console.log('此设备阈值：'+JSON.stringify(tmodels.upOne))
        upone = parseFloat(tmodels.upOne);
        uptwo = parseFloat(tmodels.upTwo);
        downone = parseFloat(tmodels.downOne);
        downtwo = parseFloat(tmodels.downTwo);
        if (tmodels.name == "Imba") {
          value = parseFloat(value) * 100;
        } else {
          value = parseFloat(value);
        }

        if (numRe.test(value) || floatRe.test(value)) {
          if (
            (uptwo >= value && value >= upone && uptwo != -1 && upone != -1) ||
            (downtwo <= value && value <= downone && downone != -1 && downtwo != -1)
          ) {
            levels = 1;
            if (tmodels.name == "W" || tmodels.name == "kw") {
              this.WInsPowerState = this.yellowState[1];
            }
            //console.log("报警值："+value)
            //此处改变仪表盘颜色
          } else if ((value >= uptwo && uptwo != -1) || (value <= downtwo && downtwo != -1)) {
            levels = 2;
            if (tmodels.name == "W") {
              this.WInsPowerState = this.redState[1];
            }
          }
        } else {
          levels = 0;
          if (tmodels.name == "W" || tmodels.name == "kw") {
            this.WInsPowerState = this.greenState[1];
          }
        }
        newResult = {
          name: tmodels.name,
          levels: levels,
          times: nottimestamp,
          code: code,
        };
      }

      return newResult;
    },
    //三相不平衡报警逻辑
    CheckNotifImba(tmodels, value, nottimestamp, condion, iavg, code) {
      let upone = ""; //上限一级
      let uptwo = ""; //上限二级
      let downone = ""; //下限一级
      let downtwo = ""; //下限二级
      let levels = 0;
      let newResult = {};
      var numReg = /^[0-9]*$/;
      var floatReg = /^[0-9]+\.?[0-9]+?$/;
      var numRe = new RegExp(numReg);
      var floatRe = new RegExp(floatReg);

      if (tmodels) {
        upone = parseFloat(tmodels.upOne);
        uptwo = parseFloat(tmodels.upTwo);
        downone = parseFloat(tmodels.downOne);
        downtwo = parseFloat(tmodels.downTwo);
        let icondion = parseFloat(condion.upOne) / 100; //百分比
        let iaverage = parseFloat(iavg);
        let rate = parseFloat(this.ratedCurrent);
        if (tmodels.name == "Imba") {
          value = parseFloat(value) * 100;
        } else {
          value = parseFloat(value);
        }

        if (numRe.test(value) || floatRe.test(value)) {
          if (uptwo >= value && value >= upone && iaverage >= icondion * rate && uptwo != -1 && upone != -1) {
            levels = 1;
          } else if (value >= uptwo && iaverage >= icondion * rate && uptwo !=-1 ) {
            levels = 2;
          }
        } else {
          levels = 0;
        }
        newResult = {
          name: tmodels.name,
          levels: levels,
          times: nottimestamp,
          code: code,
        };
      }

      return newResult;
    },
    refreshToken() {
      var that = this;
      //已登录的进行token定时刷新
      setTimeout(() => {
        //console.log('刷新了')
        //先检查是否已登录
        var curhref = window.location.href;
        //login页面不刷新、其他页面20分钟刷一次
        if (curhref.split("#").length > 1 && curhref.split("#")[1] == "/login")
          //登录页面不刷新
          return;
        //刷新token
        refreshMyToken(that);
      }, 1000 * 1201);
    },
    async OutTempData(labid){
      GetOutTempData(labid).then((res) => {
        if (res.success) {
          this.outTempV1 = res.result.item1;
          this.outHumV1 = res.result.item2;
        }
      });


    },
    //随机数
    randomNum(m, n) {
      var num = Math.floor(Math.random() * (m - n) + n);
      return num;
    },
    sortByKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    imgurl1: function () {
      let ilevel = this.testlev;
      //console.log("告警级别"+ilevel)
      if (ilevel == "0") {
        return require("@/assets/img/TopState1G.png"); // n_green;
      }
      if (ilevel == "1") {
        return require("@/assets/img/TopState1Y.png"); // this.imgurlY;
      }
      if (ilevel == "2") {
        return require("@/assets/img/TopState1R.png"); //this.imgurlR;
      }
      //console.log("显示图片路径"+this.imgurl)
    },
    imgurl2: function () {
      let ithlevel = this.THlev;
      if (ithlevel == "0") {
        return require("@/assets/img/TopState3G.png");
      }
      if (ithlevel == "1") {
        return require("@/assets/img/TopState3Y.png");
      }
      if (ithlevel == "2") {
        return require("@/assets/img/TopState3R.png");
      }
    },
    imgurl3: function () {
      let ithlevel = this.PUElev;
      if (ithlevel == "green") {
        return require("@/assets/img/TopState2G.png");
      }
      if (ithlevel == "yellow") {
        return require("@/assets/img/TopState2Y.png");
      }
      if (ithlevel == "red") {
        return require("@/assets/img/TopState2R.png");
      }
    },
    sortElcList: function () {
      //console.log(this.sortByKey(this.ElcList,'name'))
      return this.sortByKey(this.ElcList, "name");
    },
    sortTHList: function () {
      //console.log(this.sortByKey(this.THList,'code'))
      return this.sortByKey(this.THList, "code");
    },
  }),

  watch: {
    ethLevel(val, oldval) {},
  },
  mounted() {
    this.Elc3 = echarts.init(document.getElementById("Elc3"));
    this.ElcTri = echarts.init(document.getElementById("ElcTri"));
    this.InsPower = echarts.init(document.getElementById("InsPower"));
    this.ElcKPI = echarts.init(document.getElementById("ElcKPI"));
    this.NowPUE = echarts.init(document.getElementById("NowPUE"));
    this.LastPUE = echarts.init(document.getElementById("LastPUE"));
    this.Temperature = echarts.init(document.getElementById("Temperature"));
    this.Humidity = echarts.init(document.getElementById("Humidity"));
    window.addEventListener("resize", () => {
      this.Elc3.resize();
    });
    window.addEventListener("resize", () => {
      this.ElcTri.resize();
    });
    window.addEventListener("resize", () => {
      this.InsPower.resize();
    });
    window.addEventListener("resize", () => {
      this.ElcKPI.resize();
    });
    window.addEventListener("resize", () => {
      this.NowPUE.resize();
    });
    window.addEventListener("resize", () => {
      this.LastPUE.resize();
    });
    window.addEventListener("resize", () => {
      this.Temperature.resize();
    });
    window.addEventListener("resize", () => {
      this.Humidity.resize();
    });
    this.RegionMyService(true);
    this.refreshToken();
    //this.thtestLevList.push("0");

    //实时时间
    let that = this;
    let numtime = this.randomNum(10, 59);
    this.timer = setInterval(function () {
      that.timesNow = new Date().toLocaleString();
    }, 1000);
    let ip = getCookie("LocalIp");
    if (ip != "135.251.16.16") {
      setInterval(function () {
        //connection.stop()
        //that.reload()
        //window.location.reload()
        that.RegionMyService(false);
      }, 1000 * 60 * 60 * 8);
    }

    //1小时获取下温湿度数据
    this.tempHumTimer = setInterval(function () {
        let cuid =   getCookie("currLabId");
        that.OutTempData(cuid);
      }, 1000 * 60 * 60 * 1);
    //实时数据
    that.$nextTick(() => {
      //console.log('测试')
      this.Echarts3Elc();
      this.EchartsTri();
      this.EchartsInsPower();
      this.EchartsElcKPI();
      this.EchartsNowPUE();
      this.EchartsLastPUE();
      this.EchartsTemperature();
      this.EchartsHumidity();
    });
  },
  beforeUpdate: function () {},
  beforeDestroy: function () {
    // if (this.timer) {
    //   clearInterval(this.timer);
    // }

    if (this.Humidity) {
      this.Humidity.dispose();
    }
    if (this.Elc3) {
      this.Elc3.dispose();
    }
    if (this.ElcTri) {
      this.ElcTri.dispose();
    }
    if (this.InsPower) {
      this.InsPower.dispose();
    }
    if (this.Temperature) {
      this.Temperature.dispose();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.allH);

    clearInterval(this.ETabstimer);
    this.ETabstimer = null;
    clearInterval(this.TTabstimer);
    this.TTabstimer = null;
    clearInterval(this.outTTabstimer);
    this.outTTabstimer = null;
    clearInterval(this.RealpueTimer);
    this.RealpueTimer = null;
    clearInterval(this.tempHumTimer)
    this.tempHumTimer = null;

  },
};
</script>

<style scoped>
.realPUE {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  min-width: 50px;
  padding-top: 3px;
}
.realPUE strong {
  border: 1px solid #48617b;
  background: rgba(65, 108, 172, 0.2);
  border-radius: 5px;
  padding: 3px 0px;
  display: block;
  font-size: 18px;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  transform: scale(0.95);
}

.el-carousel__item:nth-child(2n) {
  /* height: 20px;
     width: 35%; */
  transform: scale(0.95);
}

.el-carousel__item:nth-child(2n + 1) {
  transform: scale(0.95);
}
.OutDoorTH {
  position: absolute;
  top: 18px;
  right: 20px;
  z-index: 9;
  width: calc(85% - 178px);
  text-align: right;
}
.OutDoorTH span {
  font-size: 12px;
  line-height: 16px;
  display: block;
}
.OutDoorTH span strong {
  font-size: 12px;
  color: #fff;
  display: block;
}
.righttitle {
  text-align: right;
  border-left: 0;
  border-right: 5px solid #a9d5e4;
  padding: 0px 10px 0px 0px;
  background-image: linear-gradient(to left,rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0));
}
</style>
